module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-165.7e47e4c8.jpg";